// extracted by mini-css-extract-plugin
export default {"HeaderBackground":"PageTitleCard_HeaderBackground__Df7kt","CardBody":"PageTitleCard_CardBody__fj6Lz"};